// extracted by mini-css-extract-plugin
module.exports = {"GiftPostIntroContainer":"GiftPostIntro_GiftPostIntroContainer__ECksm","Dismiss":"GiftPostIntro_Dismiss__M86nJ"};